import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../Components/Service/apiservices";

const Faqs = ({ dataObj = {} }) => {
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getFaqData();
  }, []);

  const getFaqData = () => {
    const postData = {
      home_faq_multi_id: dataObj.home_faq_multi_id || ''
    };

    ApiService.postData('categoryFaqs', postData)
      .then((res) => {
        if (res.status == 'success') {
          setFaqData(res.faqCatData);
        } else {
          console.error("Failed to fetch data:", res.message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  return (
    <section className="faqs">
      <Container>
 {dataObj.home_faq_display_title == "1" && (
        <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
          <ul className="ps-0 w-100">
            {faqData.map((category, index) => (
              <li key={index}>
                <button
                  className={`nav-link ${index == 0 ? 'active' : ''}`}
                  id={`nav-${category.category_id}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target={`#nav-${category.category_id}`}
                  type="button"
                  role="tab"
                  aria-controls={`nav-${category.category_id}`}
                  aria-selected={index == 0}
                >
                  {category.category_name}
                </button>
              </li>
            ))}
          </ul>
        </div>
 )}
        <div className="tab-content" id="nav-tabContent">
          {faqData.map((category, index) => (
            <div
              key={index}
              className={`tab-pane fade ${index == 0 ? 'show active' : ''}`}
              id={`nav-${category.category_id}`}
              role="tabpanel"
              aria-labelledby={`nav-${category.category_id}-tab`}
            >
              <h4 className="mt-5">{category.category_name}</h4>
              <div className="accordion" id={`accordion-${category.category_id}`}>
                {category.faqs.map((faq, faqIndex) => (
                  <div className="accordion-item" key={faqIndex}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${faqIndex == 0 ? '' : 'collapsed'}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${category.category_id}-${faqIndex}`}
                        aria-expanded={faqIndex == 0}
                        aria-controls={`collapse-${category.category_id}-${faqIndex}`}
                      >
                        {faq.faq_name}
                      </button>
                    </h2>
                    <div
                      id={`collapse-${category.category_id}-${faqIndex}`}
                      className={`accordion-collapse collapse ${faqIndex == 0 ? 'show' : ''}`}
                      data-bs-parent={`#accordion-${category.category_id}`}
                    >
                      <div className="accordion-body">
                        <p dangerouslySetInnerHTML={{ __html: faq.faq_desc }}></p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Faqs;
